module.exports = __webpack_public_path__ + "static/media/fresh-lenslilac.9f7e4a8e.png";